<template>
  <Modal
    name="SHOW_HOST_ONBOARDING_AGREEMENT"
    :title="$parent.currentAgreement == 'CONTRACT' ? 'Contrato' : 'Termos'"
    fullscreen
  >
    <template v-slot:body>
      <div>
        <v-row class="mb-2">
          <v-col>
            <p v-html="$parent.agreementStep.agreements.find((it) => it.type == $parent.currentAgreement).html_content" />
          </v-col>
        </v-row>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ModalShowAgreement',

  components: {
    Modal
  },

  computed: {
    ...mapGetters(['isLoading']),
  },

  methods: {
    ...mapActions(['closeModal'])
  },
}
</script>
